import React, { useState } from 'react';
import './SignUp.css';

import DetoxaLogo from '../../assets/logo.png';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { Link } from 'react-router-dom';
import axios from 'axios';
import GirlPhoneImage from '../../assets/login-assets/girl_phone.png';
import PhoneImage from '../../assets/login-assets/phone_group.png';
import { setUsername, setBearerToken, setPasswordofuser } from '../../redux/admin/userActions.js';
import Checkbox from '@material-ui/core/Checkbox';

const useStyles = makeStyles((theme) => ({
	root: {
		'& > *': {
			margin: theme.spacing(1),
			width: '40ch',
		},
	},
}));

const SignUp = (props) => {
	const dispatch = useDispatch();
	const classes = useStyles();
	const [checked, setChecked] = useState(false);
	const [fullname, setFullname] = useState('');
	const [email, setEmail] = useState('');
	const [phoneNumber, setPhoneNumber] = useState('');
	const [password, setPassword] = useState('');
	const [repeatedPassword, setRepeatedPassword] = useState('');

	const handlesubmit = (event) => {
		event.preventDefault();
		if (password !== repeatedPassword) {
			alert('Passwords do not match');
			return;
		}
		axios
			.post('https://detoxa-dev.herokuapp.com/auth/user/register', {
				name: fullname,
				phone: phoneNumber,
				password: password,
				email: email,
			})
			.then((res) => {
				alert('You are now registered Please Log in :)');
				dispatch(setUsername(fullname));
				dispatch(setBearerToken(res.data.token));
				dispatch(setPasswordofuser(password));
				setFullname('');
				setPhoneNumber('');
				setPassword('');
				setEmail('');
				setRepeatedPassword('');
				setChecked(false);
			})
			.catch((err) => {
				console.log(err);
			});
	};

	const handleChange = (event) => {
		setChecked(!checked);
	};

	return (
		<div className='AuthTemplate'>
			<div className='row'>
				<div className='col s4 hide-on-med-and-down'>
					<img src={GirlPhoneImage} className='girl-phone' />
				</div>
				<div className='col s4 hide-on-med-and-down'>
					<img src={PhoneImage} className='phone-group' />
				</div>
				<div className='col s12 l4 data'>
					<div className='SignUp'>
						<img src={DetoxaLogo} alt='Detoxa Logo' />
						<form>
							<div className={classes.root}>
								<input
									id='full-name'
									label='Full Name'
									placeholder='Full Name'
									type='text'
									value={fullname}
									onChange={(event) => {
										setFullname(event.target.value);
									}}
									required
								/>
								<input
									id='email'
									label='Email'
									placeholder='Email'
									type='text'
									value={email}
									onChange={(event) => {
										setEmail(event.target.value);
									}}
									required
								/>
								<input
									id='mobile'
									label='Mobile'
									placeholder='Mobile'
									type='text'
									value={phoneNumber}
									onChange={(event) => {
										setPhoneNumber(event.target.value);
									}}
									required
								/>
								<input
									id='password'
									label='Password'
									placeholder='Password'
									type='password'
									value={password}
									onChange={(event) => {
										setPassword(event.target.value);
									}}
									required
								/>
								<input
									id='repeated-password'
									label='Repeat Password'
									placeholder='Repeat Password'
									type='password'
									value={repeatedPassword}
									onChange={(event) => {
										setRepeatedPassword(event.target.value);
									}}
									required
									helperText={
										password !== repeatedPassword
											? "Passwords don't match"
											: null
									}
								/>
								<div className='check-box'>
									<div>
										<Checkbox
											checked={checked}
											color='default'
											onClick={handleChange}
											inputProps={{
												'aria-label': 'checkbox with default color',
											}}
										/>
									</div>
									<p>I agree to the Terms & Conditions</p>
								</div>
							</div>
							<div className='buttons'>
								<button type='submit' onClick={handlesubmit}>
									Sign Up
								</button>
								<Link to='/login'>Sign In</Link>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SignUp;
